module.exports = __webpack_public_path__ + "img/ln2.57d3262d.png";